import React, {useState} from "react";
import {Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import UserInfoForm from "../Common/UserInfoForm";
import PrivacyPolicy from "../Common/PrivacyPolicy";
import {useDispatch} from "react-redux";
import {ReminderSettingsSubmitEvent} from "../../../Containers/ReminderSettingsContainer";
import {InfoSubmitEvent} from "../../../Containers/RootContainer";
import ReminderActions from "../../../Redux/reminderRedux";
import {ServiceCardType} from "../Types";
import ThankYou from "../Common/ThankYou";

interface InspectionReminderProps {
    orderReminder: boolean
    thankYouMessage?: string
    onBack?: () => void
    serviceCard?: ServiceCardType
}

const InspectionReminder = ({orderReminder, thankYouMessage, onBack, serviceCard}: InspectionReminderProps) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const [showPrivacyPolicy, setShowPrivacyPolicy] = useState<boolean>(false)
    const [done, setDone] = useState<boolean>(!orderReminder)
    const [values, setValues] = useState<InfoSubmitEvent>({
        registerNumber: serviceCard?.sale?.tasks?.[0]?.vehicle?.registrationNumber,
        firstName: serviceCard?.sale?.customer?.firstName,
        lastName: serviceCard?.sale?.customer?.lastName,
        email: serviceCard?.sale?.customer?.email,
        phone: serviceCard?.sale?.customer?.phone,
        acceptTermsOfUse: false,
    } as InfoSubmitEvent);

    const isReadyToSend = (values: InfoSubmitEvent) => {
        const {
            acceptTermsOfUse,
            firstName,
            lastName,
            email,
            phone,
            registerNumber,
        } = values
        return acceptTermsOfUse &&
            firstName !== '' &&
            lastName !== '' &&
            email !== '' &&
            phone !== '' &&
            registerNumber !== ''
    }

    const onSubmitReminderUpdate = (info: InfoSubmitEvent) => {
        const reminderSettings: ReminderSettingsSubmitEvent = {
            email: info.email,
            phone: info.phone,
            registrationNumber: info.registerNumber,
            firstName: info.firstName,
            lastName: info.lastName,
        }
        console.log('submit reminder', reminderSettings)
        dispatch(ReminderActions.postReminderSettings(reminderSettings))
        setDone(true)
    }

    if (showPrivacyPolicy === true) {
        return (
            <PrivacyPolicy onClose={() => setShowPrivacyPolicy(false)} />
        )
    }

    if (done === true) {
        return (
            <ThankYou message={thankYouMessage}/>
        )
    }

    return (<>
        <UserInfoForm
            prefill={values}
            onSubmitInfo={onSubmitReminderUpdate}
            onBack={onBack}
            askRegisterNumber={true}
            isReadyToSend={isReadyToSend}
            setShowPrivacyPolicy={setShowPrivacyPolicy}
            onChange={setValues}
            header={<Typography variant="h6" gutterBottom>
                {t('selfService.orderInspectionReminder')}
            </Typography>}
        />
    </>)
}

export default InspectionReminder
